// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__gI0Fy","form__field":"styles_form__field__0iemP","form__button":"styles_form__button__UwGnf","form__section":"styles_form__section__dB_QT"};